import { useContext } from "react";
import { RoomContext } from "../RoomContext";

export default function useLocalTracks() {
  const { room } = useContext(RoomContext);

  let videoTrack = Array.from(room.localParticipant.videoTracks.values())[0]
    .track;
  let audioTrack = Array.from(room.localParticipant.audioTracks.values())[0]
    .track;

  return { videoTrack: videoTrack, audioTrack: audioTrack };
}
